import { Alert, Box, Link, TableCell, TableRow, Typography } from "@mui/material";
import { PaginatedTable } from "../../generic/components/paginated-table/paginated-table";
import { StringAvatar } from "../../generic/components/string-avatar";

import type { UUID } from "../../../utils/uuid";
import type { FC } from "react";

const DEFAULT_PAGE_SIZE = 25;

export const PeopleList: FC<{
  people: {
    id: UUID | null;
    email: string | null;
    employee_id: string | null;
    name: string | null;
  }[];
  rowsPerPage?: number;
}> = ({ people, rowsPerPage = DEFAULT_PAGE_SIZE }) => {
  if (people.length === 0) return <Alert severity="info">No people found</Alert>;

  return (
    <PaginatedTable
      data={people}
      config={{
        headers: ["Name", "Employee ID", "Type"],
        defaultRowsPerPage: rowsPerPage,
        search: { keys: ["name", "employee_id", "email"], threshold: 0 },
        sort: {
          default: {
            column: "name",
            direction: "asc",
          },
          options: [
            { value: "name", label: "Name" },
            { value: "employee_id", label: "Employee ID" },
            { value: "email", label: "Email" },
          ],
        },
      }}
      renderRow={(person) => (
        <TableRow>
          <TableCell>
            <Box sx={{ alignItems: "center", display: "flex" }}>
              <Link href={`/recipient-activity/${person.id}`}>
                <StringAvatar name={person.name ?? "Unkown"} />
              </Link>
              <Box sx={{ ml: 1 }}>
                <Link
                  href={`/recipient-activity/${person.id}/overview`}
                  color="inherit"
                  variant="subtitle2"
                >
                  {person.name}
                </Link>
                <Typography color="textSecondary" variant="body2">
                  {person.email}
                </Typography>
              </Box>
            </Box>
          </TableCell>
          <TableCell>{person.employee_id}</TableCell>
          <TableCell>
            <Typography color="primary" variant="subtitle2">
              Employee
            </Typography>
          </TableCell>
        </TableRow>
      )}
    />
  );
};
